/**
 * Строки кабинета: список организаций, онбординг, хаб настроек, правила, подписка.
 *
 * Словарь кабинета разрезан на четыре файла по зонам ответственности (`dict.business`,
 * `dict.calendar`, `dict.settings`, а `dict.ts` их склеивает), и это не эстетика: над
 * кабинетом работают параллельно, а один общий файл строк — гарантированный конфликт
 * на каждом коммите. Форма записи та же, что в основном словаре: пара `[ru, uz]`,
 * не дающая добавить русский текст и забыть узбекский.
 */

export const BUSINESS_STRINGS = {
  // ── Нижняя навигация кабинета ──
  navCalendar: ['Календарь', 'Kalendar'],
  navSettings: ['Настройки', 'Sozlamalar'],
  navPlan: ['Тариф', 'Tarif'],

  // ── Список организаций и вход в кабинет ──
  bizHomeTitle: ['Мой бизнес', 'Mening biznesim'],
  bizHomeSub: ['Управление записями', 'Yozuvlarni boshqarish'],
  bizHomeEmpty: [
    'У вас пока нет организации. Создайте её — это займёт минуту.',
    'Sizda hali tashkilot yoʻq. Uni yarating — bir daqiqa vaqt oladi.',
  ],
  bizCreate: ['Создать организацию', 'Tashkilot yaratish'],
  bizOpen: ['Открыть', 'Ochish'],
  /* Черновики и опубликованные разведены заголовками, а не одним списком с бейджами:
     черновик вперемешку с работающими читается как «уже работает», и владелец ждал бы
     клиентов из каталога, которых там нет (README, решение 3). */
  bizSecDrafts: ['Черновики', 'Qoralamalar'],
  bizSecPublished: ['В каталоге', 'Katalogda'],

  // ── Статус публикации ──
  bizDraft: ['Черновик', 'Qoralama'],
  bizPublished: ['В каталоге', 'Katalogda'],
  /* Организация попадает в каталог только по кнопке и только заполненной: хотя бы одна
     активная услуга и один активный специалист (README, решение 3). */
  bizDraftNote: [
    'Организация не видна в каталоге. Добавьте услугу и специалиста, затем опубликуйте.',
    'Tashkilot katalogda koʻrinmaydi. Xizmat va mutaxassis qoʻshing, soʻng nashr eting.',
  ],
  bizPublish: ['Опубликовать', 'Nashr etish'],
  bizUnpublish: ['Снять с публикации', 'Nashrdan olish'],

  /* ── Архив («История») ──
     Не удаление: записи, оценки и ограничения клиентов остаются. Поэтому кнопка спокойная,
     не красная, а подтверждение объясняет, что действие обратимо.
     УЗБЕКСКИЙ ТЕКСТ ЭТОГО БЛОКА ТРЕБУЕТ ПРОВЕРКИ НОСИТЕЛЕМ (README, правила для текстов). */
  bizSecHistory: ['История', 'Tarix'],
  bizArchive: ['В историю', 'Tarixga oʻtkazish'],
  bizArchiveHint: [
    'Организация уйдёт с главного экрана и из каталога. Записи, оценки и ограничения клиентов сохранятся. Вернуть её можно в разделе «История».',
    'Tashkilot bosh ekrandan va katalogdan yoʻqoladi. Yozuvlar, baholar va mijozlarga qoʻyilgan cheklovlar saqlanadi. Uni «Tarix» boʻlimidan qaytarish mumkin.',
  ],
  bizArchiveT: ['Убрать в историю?', 'Tarixga oʻtkazamizmi?'],
  bizArchiveB: [
    'Организация пропадёт из каталога, и записаться в неё будет нельзя. Данные не удаляются — её можно восстановить.',
    'Tashkilot katalogdan yoʻqoladi va unga yozilib boʻlmaydi. Maʼlumotlar oʻchirilmaydi — uni tiklash mumkin.',
  ],
  bizRestore: ['Восстановить', 'Tiklash'],

  // ── Онбординг ──
  onbTitle: ['Новая организация', 'Yangi tashkilot'],
  /* Первый вопрос онбординга: один человек или команда (`businesses.is_solo`).
     От ответа зависит, чьё имя спрашивать дальше и заводить ли специалиста автоматически.

     СПРАШИВАЕМ ПРО КОЛИЧЕСТВО ЛЮДЕЙ, А НЕ ПРО ПРОФЕССИЮ. Первая версия вопроса звучала
     «Кто вы: заведение или частный мастер», и это ломалось на половине отраслей: репетитор
     и частный врач не «мастера», а «заведение» — не то слово для человека, ведущего приём
     у себя дома. Отраслевой термин (`specialistTerm`: мастер, врач, преподаватель) подставить
     сюда нельзя: отрасль спрашивается СЛЕДУЮЩИМ шагом, на этом её ещё нет.

     «Работаю один» и «Нас несколько» верны для всех девяти отраслей разом и не требуют
     ни ветвления, ни перестановки шагов. Примеры профессий ушли в подписи — там они
     помогают, а не обещают лишнего. */
  onbWho: ['Как вы работаете', 'Qanday ishlaysiz'],
  onbWhoPlace: ['Нас несколько', 'Bizda jamoa'],
  onbWhoPlaceNote: [
    'Салон, клиника, центр, автосервис. Специалистов добавите сами.',
    'Salon, klinika, markaz, avtoservis. Mutaxassislarni oʻzingiz qoʻshasiz.',
  ],
  onbWhoSolo: ['Работаю один', 'Yolgʻiz ishlayman'],
  onbWhoSoloNote: [
    'Барбер, репетитор, врач, грумер сам на себя. Клиенты записываются лично к вам.',
    'Barber, repetitor, shifokor, gruumer oʻziga ishlaydi. Mijozlar shaxsan sizga yoziladi.',
  ],
  onbName: ['Название', 'Nomi'],
  onbNameSolo: ['Ваше имя', 'Ismingiz'],
  onbNameSoloPh: ['Акбар Рустамов', 'Akbar Rustamov'],
  onbNamePh: ['Барбершоп на Амира Темура', 'Amir Temur koʻchasidagi sartaroshxona'],
  onbType: ['Отрасль', 'Soha'],
  /* Отрасль задаёт шаг сетки, окно отмены, лимиты, срок бана и название специалиста.
     Значения КОПИРУЮТСЯ в организацию при создании и потом правятся вручную: правка
     пресета не должна менять правила у живых организаций (AGENTS.md, правило 5). */
  onbTypeNote: [
    'Отрасль задаёт стартовые правила: шаг сетки, окно отмены, лимиты. Потом их можно изменить.',
    'Soha boshlangʻich qoidalarni belgilaydi: panjara qadami, bekor qilish oynasi, limitlar. Keyin oʻzgartirish mumkin.',
  ],
  onbAddress: ['Адрес', 'Manzil'],
  onbAddressPh: ['Ташкент, ул. Амира Темура, 15', 'Toshkent, Amir Temur koʻchasi, 15'],
  onbSubmit: ['Создать', 'Yaratish'],
  /* Slug печатается на QR-наклейках и не меняется НИКОГДА, даже при переименовании. */
  onbSlugNote: [
    'Адрес организации создаётся из названия один раз и не меняется — он печатается на QR-наклейках.',
    'Tashkilot manzili nomdan bir marta yaratiladi va oʻzgarmaydi — u QR-stikerlarga chop etiladi.',
  ],

  // ── Онбординг: живая подстановка пресета отрасли ──
  /* Единственное место, где пресет читается законно: организации ещё нет. После создания
     те же поля берутся только из строки организации (AGENTS.md, правило 5). */
  onbPresetTitle: ['Что получит организация', 'Tashkilot nimaga ega boʻladi'],
  onbPickFirst: [
    'Выберите отрасль — и здесь появятся её правила.',
    'Sohani tanlang — uning qoidalari shu yerda paydo boʻladi.',
  ],
  onbPresetNote: [
    'Значения копируются в организацию при создании. Любое меняется позже в настройках — правка пресета живые организации не переписывает.',
    'Qiymatlar yaratilganda tashkilotga nusxalanadi. Har birini keyinroq sozlamalarda oʻzgartirish mumkin — presetni tahrirlash ishlayotgan tashkilotlarni qayta yozmaydi.',
  ],
  onbSlotStep: ['Шаг сетки слотов', 'Slot panjarasi qadami'],
  onbTrial: ['Пробный период', 'Sinov muddati'],
  onbFreeTier: ['Постоянный Free-тариф', 'Doimiy Free tarifi'],
  /* «Соло» и «мульти» требовали догадки, за что платят. Формулировка объясняет это сама
     (прототип, ключи pSolo/pMulti). */
  onbPriceSolo: ['Подписка для соло-мастера', 'Yakka usta uchun obuna'],
  onbPriceMulti: ['Подписка для команды', 'Jamoa uchun obuna'],
  onbTerm: ['Как называем специалиста', 'Mutaxassis qanday ataladi'],
  /* Отрасль обязательна и не имеет значения по умолчанию: подстановка барбершопа дала бы
     стоматологии двухчасовое окно отмены вместо суточного (AGENTS.md, правило 7). */
  onbNeedType: ['Выберите отрасль', 'Sohani tanlang'],

  // ── Хаб настроек ──
  setTitle: ['Настройки', 'Sozlamalar'],
  setServices: ['Услуги и цены', 'Xizmatlar va narxlar'],
  setStaff: ['Специалисты', 'Mutaxassislar'],
  setSchedule: ['Часы работы', 'Ish vaqti'],
  setTimeOff: ['Отпуска и отсутствия', 'Taʼtil va yoʻqliklar'],
  setRules: ['Правила и антиспам', 'Qoidalar va antispam'],
  setProfile: ['Название и адрес', 'Nomi va manzili'],
  setSave: ['Сохранить', 'Saqlash'],
  setSaved: ['Сохранено', 'Saqlandi'],
  /* Slug и отрасль показаны только на чтение: их нет в `UpdateBusinessInput`, и бэкенд
     отвергает их в теле, а не игнорирует. Поле ввода, которое ничего не меняет, хуже
     его отсутствия — оно обещает. */
  setTypeNote: [
    'Отрасль после создания не меняется: её значения уже скопированы в организацию и правятся в «Правилах и антиспаме».',
    'Soha yaratilgandan keyin oʻzgarmaydi: uning qiymatlari tashkilotga nusxalangan va «Qoidalar va antispam»da tahrirlanadi.',
  ],
  setPublishedNote: [
    'Организация видна клиентам в каталоге. Снятие с публикации убирает её оттуда; записи, услуги и настройки остаются.',
    'Tashkilot katalogda mijozlarga koʻrinadi. Nashrdan olish uni oʻsha yerdan olib tashlaydi; yozuvlar, xizmatlar va sozlamalar qoladi.',
  ],

  // ── Проверка полей формы ──
  errNameShort: [
    'Название короче {min} символов.',
    'Nom {min} ta belgidan qisqa.',
  ],
  errNameLong: ['Название длиннее {max} символов.', 'Nom {max} ta belgidan uzun.'],
  errAddressLong: ['Адрес длиннее {max} символов.', 'Manzil {max} ta belgidan uzun.'],

  // ── Правила и антиспам ──
  ruleSlotStep: ['Шаг сетки, мин', 'Panjara qadami, daq'],
  ruleCancelWindow: ['Окно безопасной отмены, ч', 'Xavfsiz bekor qilish oynasi, soat'],
  ruleMaxActive: ['Максимум активных записей', 'Faol yozuvlar maksimumi'],
  ruleCooldown: ['Пауза между записями, мин', 'Yozuvlar orasidagi pauza, daq'],
  ruleLocalBan: ['Срок локального ограничения, дн', 'Mahalliy cheklov muddati, kun'],
  ruleReminders: ['Напоминания за, ч', 'Eslatmalar, soat oldin'],
  rulesNote: [
    'Значения скопированы из пресета отрасли при создании. Меняются только здесь и только у вашей организации.',
    'Qiymatlar yaratilganda soha shablonidan nusxalangan. Faqat shu yerda va faqat sizning tashkilotingizda oʻzgaradi.',
  ],
  /* Владелец правит защиту от спама и санкции за неявку — он обязан понимать цену правки.
     Поле «Максимум активных записей» без пояснения выглядит как настройка витрины,
     а на деле это лимит по всей платформе (ТЗ §8). */
  ruleSlotStepNote: [
    'Через сколько минут начинается следующий слот. Мельче шаг — плотнее сетка, но длиннее список времени у клиента.',
    'Keyingi slot necha daqiqadan soʻng boshlanadi. Qadam kichik boʻlsa — panjara zichroq, ammo mijozdagi vaqt roʻyxati uzunroq.',
  ],
  ruleCancelWindowNote: [
    'До какого момента клиент отменяет запись без последствий. После этой границы отмена считается поздней: санкций нет, но вы видите пометку в статистике.',
    'Mijoz yozuvni oqibatsiz qachongacha bekor qila oladi. Bu chegaradan keyin bekor qilish kech hisoblanadi: jarima yoʻq, lekin statistikada belgi koʻrinadi.',
  ],
  ruleMaxActiveNote: [
    'Сколько будущих записей клиент держит одновременно — по всей платформе, не только у вас. Защита от спама: без лимита один человек занимает весь день.',
    'Mijoz bir vaqtda nechta kelgusi yozuv saqlaydi — butun platforma boʻyicha, faqat sizda emas. Spamdan himoya: limitsiz bir odam butun kunni band qiladi.',
  ],
  ruleCooldownNote: [
    'Сколько ждать между двумя записями подряд. Тоже защита от спама — от перебора слотов подряд.',
    'Ketma-ket ikki yozuv orasida qancha kutish kerak. Bu ham spamdan himoya — slotlarni ketma-ket tanlashdan.',
  ],
  ruleLocalBanNote: [
    'На сколько дней закрывается запись именно к вам после второй неявки этого клиента у вас. Глобальный бан за третью неявку платформа считает сама.',
    'Shu mijozning sizdagi ikkinchi kelmasligidan soʻng aynan sizga yozilish necha kunga yopiladi. Uchinchi kelmaslik uchun global taqiqni platforma oʻzi hisoblaydi.',
  ],
  ruleRemindersNote: [
    'За сколько часов до визита уходит напоминание в Telegram. Меньше неявок — главная ценность продукта, поэтому выключить все нельзя.',
    'Tashrifdan necha soat oldin Telegramga eslatma yuboriladi. Kamroq kelmaslik — mahsulotning asosiy qiymati, shuning uchun hammasini oʻchirib boʻlmaydi.',
  ],
  ruleReminderHours: ['за {n} ч', '{n} soat oldin'],
  /* Пустое поле — ошибка, а не ноль: `Number('')` даёт 0, и очищенный лимит активных
     записей отказывал бы каждому клиенту, а очищенный cooldown снял бы защиту молча. */
  ruleErrEmpty: [
    'Заполните поле: пустое значение не то же самое, что ноль.',
    'Maydonni toʻldiring: boʻsh qiymat nol bilan bir xil emas.',
  ],
  ruleErrNumber: ['Нужно целое число.', 'Butun son kerak.'],
  ruleErrRange: ['Допустимо от {min} до {max}.', '{min} dan {max} gacha ruxsat etilgan.'],
  ruleErrNoReminders: [
    'Оставьте хотя бы одно напоминание.',
    'Kamida bitta eslatmani qoldiring.',
  ],

  // ── Тариф ──
  planTitle: ['Тариф', 'Tarif'],
  /* Приёма платежей в этой сборке нет: провайдер не выбран (см. ACQUIRING_UZ.md).
     Экран честно об этом говорит вместо нерабочей кнопки «Оплатить». */
  planSoon: [
    'Приём оплаты подключается. Пока все возможности доступны без ограничений.',
    'Toʻlovni qabul qilish ulanmoqda. Hozircha barcha imkoniyatlar cheklovsiz mavjud.',
  ],
  planPriceTitle: ['Ваша подписка', 'Obunangiz'],
  planStatus: ['Статус', 'Holat'],
  planProUntil: ['Pro до {date}', 'Pro {date} gacha'],
  planTrialUntil: ['Пробный период до {date}', 'Sinov davri {date} gacha'],
  planFree: ['Бесплатный', 'Bepul'],
  planPay: ['Оплатить месяц', 'Bir oyga toʻlash'],
  planExtend: ['Продлить на месяц', 'Bir oyga uzaytirish'],
  planPaid: ['Оплата прошла', 'Toʻlov amalga oshdi'],
  planPaidNote: [
    'Срок подписки обновится через несколько секунд. Бот пришлёт подтверждение.',
    'Obuna muddati bir necha soniyada yangilanadi. Bot tasdiq yuboradi.',
  ],
  planPayFailed: [
    'Оплата не прошла. Попробуйте ещё раз — деньги не списаны.',
    'Toʻlov amalga oshmadi. Qaytadan urinib koʻring — pul yechilmagan.',
  ],
  planPayOutside: [
    'Оплата работает только внутри Telegram. Откройте Kanvel из бота.',
    'Toʻlov faqat Telegram ichida ishlaydi. Kanvelni botdan oching.',
  ],

  // ── Единицы измерения ──
  unitHour: ['ч', 'soat'],
  unitDay: ['дн', 'kun'],
  unitSumMonth: ['сум/мес', 'soʻm/oy'],
  unitYes: ['Да', 'Ha'],
  unitNo: ['Нет', 'Yoʻq'],
  unitFreeLight: ['Да, облегчённый', 'Ha, yengillashtirilgan'],

  // ── Общее для кабинета ──
  bizNoBusiness: ['Организация не найдена.', 'Tashkilot topilmadi.'],
} as const satisfies Record<string, readonly [string, string]>;
